import React, { useEffect, useRef, useState } from 'react';

import { getValidateHexCode } from '@features/trend-research/utils/utils';

const ColorItems = ({ onSelectionChange, selectedColors = [], multiple = false, colors = [] }) => {
	const [internalSelectedItems, setInternalSelectedItems] = useState([]);
	const [showAllStyles, setShowAllStyles] = useState(false);
	const containerRef = useRef(null);

	useEffect(() => {
		const container = containerRef.current;
		if (container) {
			if (showAllStyles) {
				container.style.height = `${container.scrollHeight}px`;
			} else {
				container.style.height = '35px';
			}
		}
	}, [showAllStyles]);

	useEffect(() => {
		if (selectedColors.length > 0 && internalSelectedItems.length === 0) {
			setInternalSelectedItems(selectedColors);
		}
	}, [selectedColors, internalSelectedItems]);

	const handleSelect = (item) => {
		let newSelectedItems;
		if (item === 'All') {
			if (internalSelectedItems.includes('All')) {
				newSelectedItems = [];
			} else {
				newSelectedItems = [...colors.map((item) => item.colorName), 'All'];
			}
		} else if (multiple) {
			if (internalSelectedItems.includes(item)) {
				newSelectedItems = internalSelectedItems.filter((selectedItem) => selectedItem !== item);
			} else {
				newSelectedItems = [...internalSelectedItems, item];
			}

			const allItemsSelected = newSelectedItems.length === colors.length;

			if (allItemsSelected && !newSelectedItems.includes('All')) {
				newSelectedItems.push('All');
			} else if (!allItemsSelected) {
				newSelectedItems = newSelectedItems.filter((selectedItem) => selectedItem !== 'All');
			}
		} else {
			newSelectedItems = [item];
		}
		setInternalSelectedItems(newSelectedItems);
		onSelectionChange(newSelectedItems);
	};

	const isAllSelected = () => {
		return colors.length + 1 === internalSelectedItems.length;
	};
	return (
		<div className="color-code-and-name text-center">
			<ul
				// className={`all-sub-button d-flex flex-wrap justify-content-center ${
				// 		showAllStyles ? 'show-all' : ''
				// 	}`}
				ref={containerRef}
				className={`d-flex flex-wrap all-sub-button ${showAllStyles ? 'show-all' : ''}`}
			>
				<li
					className={`button w-auto h-auto size32 outline mr-2 cursor-pointer ${
						isAllSelected() ? 'active' : ''
					}`}
					onClick={() => handleSelect('All')}
				>
					{isAllSelected() ? 'Unselect All' : 'Select All'}
				</li>

				{colors?.map((item, index) => (
					<li
						className={` ${internalSelectedItems.includes(item.colorName) ? 'active' : ''}`}
						key={index}
					>
						<a className="d-flex cursor-pointer" onClick={() => handleSelect(item.colorName)}>
							<span
								className="color mr-1"
								style={{ background: getValidateHexCode(item?.colorHexCode) }}
							></span>

							<span>{`${item?.colorName}(${item?.colorCount})`}</span>
						</a>
					</li>
				))}
			</ul>
			<div className={`all-button-show mt-3 mb-2 ${showAllStyles ? 'active' : ''}`}>
				<p
					className="cursor-pointer gray_dark_01 regular-14 d-inline d-flex align-items-center justify-content-center"
					onClick={() => {
						setShowAllStyles((prev) => !prev);
						//window.scrollTo(0, 100);
					}}
				>
					<span className="pr-2">{showAllStyles ? 'Hide All' : 'View All'}</span>
					<span className="angel-icon">
						<img src={`${process.env.PUBLIC_URL}/icons/chevron_down.png`} width={12} />
					</span>
				</p>
			</div>
		</div>
	);
};

export default ColorItems;
